import spinnerGif from "../../../assets/spinner.gif";
import './Spinner.css'

export default function Spinner() {
    return (
        <div className="spinner-container">
            <img className="spinner" alt="chargement..." src={spinnerGif}/>
        </div>
    )
}